module.exports = __webpack_public_path__ + "static/media/hubs4.fd0e6df7.png";